import {
  buildRouteConfig,
  buildMainLinksData,
  buildLinksData
} from "@vojomo-core/shared";

const config = [
  {
    path: "/",
    component: "Home",
    title: "Vojomo",
    notSidebar: true,
    iconPath: "icon_thunderbolt"
  },
  {
    path: "beta_launch",
    title: "Beta Launch",
    notSidebar: true,
    component: "BetaLaunch"
  },
  {
    path: "google-callback",
    title: "Google Callback",
    notSIdebar: true,
    component: "GoogleCallback"
  },
  {
    path: "roadmap",
    component: null,
    title: "Roadmap",
    iconPath: "icon_build",
    children: [
      {
        path: "roadmap",
        component: "RoadmapViewer",
        title: "View Roadmap",
        label: "View Roadmap"
      },
      {
        // My Roadmaps page — shown in sidebar, replaces the old build_roadmap hero
        path: "myroadmaps",
        component: "MyRoadmaps",
        title: "My Roadmaps",
        label: "My Roadmaps"
      },
      {
        path: "new",
        component: "NewRoadmap",
        title: "New Roadmap",
        label: "New Roadmap"
      },
      {
        // build_roadmap — not shown in sidebar; its sub-routes are still active
        path: "build_roadmap",
        component: "RoadmapBuilder",
        title: "Build Roadmap",
        notSidebar: true,
        children: [
          {
            path: ":sessionId",
            component: "RoadmapBuilderSession",
            title: "Roadmap Session",
            notSidebar: true
          },
          {
            path: "invite/:token",
            component: "RoadmapBuilderInviteAccept",
            title: "Roadmap Invitation",
            notSidebar: true
          },
          {
            path: "contribute/:roundId/:token",
            component: "ContributeProgress",
            title: "Contribute Progress",
            notSidebar: true
          }
        ]
      },
      {
        // Mountain view — session-scoped SVG visualization
        path: "mountain",
        component: null,
        title: "Mountain View",
        notSidebar: true,
        children: [
          {
            path: ":sessionId",
            component: "MountainView",
            title: "Mountain View",
            notSidebar: true,
          }
        ]
      },
      {
        // Shared roadmap view — routes preserved, not shown in sidebar
        path: "view",
        component: null,
        title: "Roadmap Share",
        notSidebar: true,
        children: [
          {
            path: ":token",
            component: "RoadmapBuilderShareView",
            title: "Shared Roadmap",
            notSidebar: true
          }
        ]
      },
      {
        // Operating tools — routes preserved for direct URL access, not shown in sidebar
        path: "operating_tools",
        component: null,
        title: "Operating Tools",
        notSidebar: true,
        children: [
          {
            path: "qbr_scoring",
            component: "QBR",
            title: "QBR Scoring",
            notSidebar: true
          },
          {
            path: "weekly_progress",
            component: "WeeklyProgress",
            title: "Weekly Progress",
            notSidebar: true
          },
          {
            // AAR route preserved here for direct URL access (legacy)
            path: "aar",
            component: "AAR",
            title: "After Action Review",
            notSidebar: true
          }
        ]
      }
    ]
  },
  {
    // Documents routes — kept for TopicViewer / DocBuilder navigation, not shown in main sidebar
    path: "documents",
    component: null,
    title: "Documents",
    notSidebar: true,
    children: [
      {
        path: "docs",
        component: "DocsList",
        title: "Documents List",
        notSidebar: true,
        children: [
          {
            path: ":topicId",
            component: "TopicViewer",
            title: "Topic",
            notSidebar: true
          },
          {
            path: ":topicId/:outputId",
            component: "TopicViewer",
            title: "Topic",
            notSidebar: true
          },
          {
            path: "create_document/:topicId",
            component: "DocBuilder",
            title: "Create Document",
            notSidebar: true
          }
        ]
      }
    ]
  },
  {
    // Practices — structured workflows & methods (AAR, Progress Checkpoint, etc.)
    path: "practices",
    component: null,
    title: "Practices",
    iconPath: "icon_gain_momentum",
    children: [
      {
        path: "aar",
        component: "AAR",
        title: "After Action Review",
        label: "After Action Review"
      }
    ]
  },
  {
    // Studio — all children notSidebar so icon click navigates directly to /studio/home
    path: "studio",
    component: null,
    title: "Studio",
    iconPath: "icon_doc_writer",
    children: [
      {
        path: "home",
        component: "StudioHome",
        title: "Studio Home",
        label: "Studio",
        notSidebar: true
      },
      {
        // Audio routes — preserved for navigation, not shown in sidebar
        path: "audio",
        component: null,
        title: "Audio",
        label: "Audio",
        notSidebar: true,
        children: [
          {
            path: "home",
            component: "AudioHome",
            title: "Audio",
            notSidebar: true
          },
          {
            path: "podcasts",
            component: "Podcasts",
            title: "Podcasts",
            label: "Podcasts",
            notSidebar: true,
            children: [
              {
                path: "share/:token",
                component: "PodcastShare",
                title: "Podcast Share",
                notSidebar: true
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: "vo",
    component: null,
    title: "Vo",
    iconPath: "icon_ai",
    children: [
      {
        path: "vochat",
        component: "Modus",
        title: "VoChat"
      }

      // {
      //   path: "manage_sources",
      //   component: "ManageSources",
      //   title: "Manage Sources",
      // },
    ]
  },
  {
    path: "learn",
    component: null,
    title: "Learn",
    iconPath: "icon_learn",
    children: [
      {
        path: "vo",
        title: "Vo",
        component: null,
        children: [
          {
            path: "collab_wvo",
            component: "CollabWVo",
            title: "Collaborating With Vo",
            label: "Collaborate With Vo",
            tabs: 1
          }
        ]
      },
      {
        path: "building_blocks",
        title: "Building Blocks",
        component: null,
        children: [
          {
            path: "roadmaps",
            component: "RoadmapsLearn",
            title: "Why Roadmaps?",
            tabs: 1
          },
          {
            path: "vision",
            component: "VisionLearn",
            title: "Vision",
            tabs: 1
          },
          {
            path: "mission",
            component: "MissionLearn",
            title: "Mission",
            tabs: 1
          },
          {
            path: "peak_ambition",
            component: "PeakAmbitionLearn",
            title: "Peak Ambition",
            tabs: 1
          },
          {
            path: "objectives",
            component: "ObjectivesLearn",
            title: "Objectives",
            tabs: 1
          }
        ]
      },
      {
        path: "glossary",
        title: "Glossary",
        component: null,
        children: [
          {
            path: "terms",
            component: "GlossaryLearn",
            title: "Glossary",
            tabs: 1
          }
        ]
      }
    ]
  },
  {
    path: "coordinator",
    component: null,
    title: "Coordinator",
    iconPath: "icon_coordinator",
    children: [
      {
        path: "workflows",
        component: "CoordinatorList",
        title: "Workflows",
        label: "Workflows"
      },
      {
        path: "studio",
        component: "CoordinatorStudio",
        title: "Studio",
        label: "Studio"
      },
      {
        path: "create",
        component: "CoordinatorCreate",
        title: "Create Workflow",
        label: "Create Workflow",
        notSidebar: true
      },
      {
        path: "workflows/:workflowId",
        component: "CoordinatorDetail",
        title: "Workflow Detail",
        notSidebar: true
      }
    ]
  },
  {
    path: "company_admin",
    component: null,
    title: "My Company",
    notSidebar: true,
    children: [
      {
        path: "users",
        component: "CompanyUsers",
        title: "Users",
        label: "Users",
        notSidebar: true
      }
    ]
  },
  {
    path: "notifications",
    component: "Notifications",
    title: "Notifications",
    notSidebar: true,
    children: [
      {
        path: ":id",
        component: "NotificationDetail",
        title: "Notification",
        notSidebar: true
      }
    ]
  },
  {
    path: "account",
    component: "Account",
    title: "Account",
    notSidebar: true
  },
  {
    path: "unauthorized",
    component: "Unauthorized",
    title: "Unauthorized",
    notSidebar: true
  }
];

export const routeConfig = buildRouteConfig(config);
export const mainLinksData = buildMainLinksData(config);

export const createLinksData = () => buildLinksData(config);

// Default linksData without onClick handlers (for backward compatibility)
export const linksData = buildLinksData(config);
